export default {"src":"/_next/static/media/globe.1dc90133.svg","height":16,"width":16};